import React, { useContext, useEffect, useState } from 'react'
import { AppState } from '../App'
import { message } from 'antd';
import { TailSpin } from 'react-loader-spinner';

const Requests = () => {
    const useAppState = useContext(AppState);
    const [myReqs, setMyReqs] = useState([{
        newAddress: "",
        oldAddress: "",
        index: 0,
        confirmations: 0,
        isConfirmed: false
    }]);
    const [reqs, setReqs] = useState([{
        newAddress: "",
        oldAddress: "",
        index: 0,
        confirmations: 0,
        isConfirmed: false
    }]);
    const [newAddress, setNewAddress] = useState("");
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);

    useEffect(() => {
        async function getData() {
            let _myReq = await useAppState.staticContract.getSelfRequests(useAppState.id);
            let _myReqArr = [];
            for(let i=0; i<_myReq.length; i++) {
                _myReqArr.push({
                    newAddress: _myReq[i].newAddress,
                    oldAddress: _myReq[i].oldAddress,
                    index: Number(_myReq[i].index),
                    confirmations: Number(_myReq[i].confirmations),
                    isConfirmed: _myReq[i].isConfirmed
                })
            }
            setMyReqs(_myReqArr);
            let _reqs = await useAppState.staticContract.getUsersRequests(useAppState.id, 10);
            let _ReqArr = [];
            for(let i=0; i<_reqs.length; i++) {
                _ReqArr.push({
                    newAddress: _reqs[i].newAddress,
                    oldAddress: _reqs[i].oldAddress,
                    index: Number(_reqs[i].index),
                    confirmations: Number(_reqs[i].confirmations),
                    isConfirmed: _reqs[i].isConfirmed
                })
            }
            setReqs(_ReqArr);
        }
        getData();
    },[useAppState.change, useAppState.walletAddress, useAppState.id])

    const changeAddress = async () => {
        setLoading(true);
        try {
            let contract = await useAppState.getContract();
            let tx = await contract.changeIdAddress(newAddress);
            await tx.wait();
            useAppState.setChange(useAppState.change + 1);
            message.success("Request Sent");
        } catch (error) {
            console.log(error);
            message.error(error.reason)
        }
        setLoading(false);
    } 

    const confirm = async (_index) => {
        setLoading2(true);
        try {
            let contract = await useAppState.getContract();
            let tx = await contract.confirm(_index);
            await tx.wait();
            useAppState.setChange(useAppState.change + 1);
            message.success("Confirmed");
        } catch (error) {
            console.log(error);
            message.error(error.reason)
        }
        setLoading2(false);
    } 

  return (
    <div className='w-full'>

        <input className='w-full p-2 outline-none border-none rounded-sm text-gray-200 bg-gray-700 bg-opacity-35' placeholder='Enter New Address' value={newAddress} onChange={(e) => setNewAddress(e.target.value)} />
        <button onClick={changeAddress} className='w-full flex justify-center items-center bg-green-500 p-2 mt-3 text-sm font-semibold'>{loading ? <TailSpin height={16} color='white' /> : "Change Address"}</button>

        {myReqs.length > 0 ? 
        <div className='w-full mt-4'>
            <h1 className='text-lg font-bold text-yellow-500'>Self Requests</h1>
            <div className='w-full flex justify-start'>
                {myReqs.map((e, i) => {
                    return (
                        <div key={i} className={`${i == 0 ? "ml-0" : "ml-4"} p-2 border-2 border-[rgba(79,206,100,0.16)] text-white bg-[rgba(85,183,80,0.14)]`}>
                            <p>Old Address: {e.oldAddress.slice(0,8)}...{e.oldAddress.slice(38)}</p>
                            <p>New Address: {e.newAddress.slice(0,8)}...{e.newAddress.slice(38)}</p>
                            <p>Confirmations: {e.confirmations}</p>
                            <p>Status: {e.isConfirmed ? "Confirmed" : "Pending"}</p>
                        </div>
                )})}
            </div>
        </div>
        : null}

        {reqs.length > 0 ? 
        <div className='w-full mt-4'>
            <h1 className='text-lg font-bold text-yellow-500'>Teams Requests</h1>
            <div className='w-full flex justify-start'>
                {reqs.map((e, i) => {
                    return (
                        <div key={i} className={`${i == 0 ? "ml-0" : "ml-4"} p-2 border-2 border-[rgba(79,206,100,0.16)] text-white bg-[rgba(85,183,80,0.14)]`}>
                            <p>Old Address: {e.oldAddress.slice(0,8)}...{e.oldAddress.slice(38)}</p>
                            <p>New Address: {e.newAddress.slice(0,8)}...{e.newAddress.slice(38)}</p>
                            <p>Confirmations: {e.confirmations}</p>
                            <p>Status: {e.isConfirmed ? "Confirmed" : "Pending"}</p>
                            {!e.isConfirmed ? <button onClick={() => confirm(e.index)} className='p-2 rounded-md mt-2 bg-yellow-500 flex justify-center items-center'>{loading2 ? <TailSpin height={14} /> : "Confirm"}</button>: null}
                        </div>
                )})}
            </div>
        </div>
        : null}
    </div>
  )
}

export default Requests